import * as React from 'react';
import { Modal, DatePicker, message, Button } from 'antd';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import { extendBidDeadline } from 'src/api/inquiry';
import { tokens } from 'src/design-system';

class ExtendBidDeadline extends React.PureComponent<any, any> {
  state: any = {
    selectedDeadline: null,
    isLoading: false,
    newDeadline: null,
  };

  componentDidMount() {
    this.setState({
      selectedDeadline: momentTimezone(this.props.cardData.validTill).tz(this.props.timezone),
      newDeadline: moment(this.props.deadline),
    });
  }

  disabledDate = (current: any) => {
    return current && current < moment(this.props.cardData.validTill);
  }

  changeBidDeadline = async (date) => {
    this.setState({
      isLoading: true,
    });
    if (moment.isMoment(date)) {
      const response: any = await extendBidDeadline({
        id: this.props.cardData.id,
        validTill: {
          dateString: date.format('YYYY-MM-DD'),
          time: date.format('HH:mm'),
        },
      });
      if (response.isSuccess) {
        this.props.handleCancel(true);
      }
    } else {
      message.error('Not a valid date.');
    }
    this.setState({
      isLoading: false,
    });

  }

  render() {
    const COLOR = {
      GREY: '#8C8C8C',
    };
    const { visible, handleCancel } = this.props;
    return (
      <Modal
        width="332px"
        title="Extend Deadline"
        visible={visible}
        onCancel={() => handleCancel(false)}
        footer={[
          <Button key="back"
          style={{ marginLeft:'16%' }}
          onClick={() => handleCancel(false)}>
            No
            </Button>,
          <Button key="submit" type="primary"
            loading={this.state.isLoading}
            style={{ background: tokens.colors.primary, border: tokens.colors.primary }}
            onClick={() => {
              this.changeBidDeadline(this.state.selectedDeadline);
            }}>
            Yes
            </Button>,
        ]}
      >
        <span style={{ color: COLOR.GREY, fontSize: `${tokens.fontSize.small}px`, fontWeight: 'bold' }}>
          Previous Validity Date</span><br />
        <DatePicker style={{ width: '100%' }}
          disabled
          value={momentTimezone(this.props.cardData.validTill).tz(this.props.timezone)}
          showTime={{ use12Hours: true, format: 'h:mm:ss A' }}
        /><br/>
        <span style={{ fontSize: `${tokens.fontSize.small}px`, fontWeight: 'bold' }}>New Validity Date</span><br />
        <DatePicker style={{ width: '100%' }}
          showTime
          allowClear={false}
          disabledDate={this.disabledDate}
          value={this.state.selectedDeadline}
          onChange={(selectedDeadline) => {
            this.setState({ selectedDeadline });
          }}
          onOk={(date) => {
            this.setState({ newDeadline : date });
          }}
        />
      </Modal>
    );
  }
}

export default ExtendBidDeadline;
